<template>
  <div class="nav-logo flex-center padding-right-10 position-relative">
    <img src="@/static/yd-logo-active.png" class="logo" />
  </div>
</template>
<script >
const __sfc_main = {};
export default __sfc_main;
</script>
<style scoped lang="scss">
  $logoH: 60px;
  $w: 30px;
  $h: 20px;
  $radius: 30px;
  .nav-logo {
    height: $logoH;
    &:before,
    &:after {
      content: '';
      display: none;
      position: absolute;
      width: $w;
      height: $h;
      top: 0;
      right: -$w;
      z-index: 2;
    }
    &:before {
      background-color: #eef5ff;
      border-radius: 0 0 $radius 0;
      width: 6px;
      height: 6px;
      overflow: hidden;
      right: -6px;
    }
    &:after {
      // ebf4ff
      background-color: #eef5ff;
      border-radius: $radius 0 0 $radius;
    }
  }
  .logo {
    width: 85px;
    height: 28px;
  }
</style>
